export default __webpack_public_path__ + "static/media/tooladd.3b74fe13.jpg";